import vlpqMarketingUtility from '@sparta.auto-loans.utilities/prequal-marketing-code-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n      <div class=\"prequal-research-section\">\n\n        <h2 class=\"headline-large cnx-light prequal-research-centered prequal-research-heading\">\n          "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"heading") : depth0), depth0)) != null ? stack1 : "")
    + "\n        </h2>\n\n        <div class=\"row\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sections") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":10},"end":{"line":29,"column":19}}})) != null ? stack1 : "")
    + "        </div>\n      </div>\n\n      <hr class=\"divider--horizontal\" />\n\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"column large-3 medium-4 small-12 "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"containerClass") : depth0), depth0))
    + "\">\n              <h3 class=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"headingClass") : depth0), depth0))
    + "\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"bullet") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":16},"end":{"line":24,"column":23}}})) != null ? stack1 : "")
    + "                "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"heading") : depth0), depth0)) != null ? stack1 : "")
    + "\n              </h3>\n              <p class=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"contentClass") : depth0), depth0))
    + "\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\n            </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <p class=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"bulletClass") : depth0), depth0))
    + "\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"bullet") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "          "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "<br />\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n<div class=\"row\">\n  <div class=\"column small-centered medium-8\">\n\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"sections") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":36,"column":13}}})) != null ? stack1 : "")
    + "\n    <div class=\"prequal-research-section\">\n      <p class=\"body-medium roboto-regular prequal-gray-research-text prequal-research-centered\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"applyDirectly") : stack1),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":8},"end":{"line":43,"column":17}}})) != null ? stack1 : "")
    + "      </p>\n    </div>\n\n  </div>\n</div>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.auto-loans.modules/prequal-auto-research-module",
  "version": "1.0.5",
  "id": "prequal-auto-research-module",
  "containerID": "autoLoansPrequalAutoResearchModule",
  "moduleName": "auto-loans-prequal-auto-research-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "prequal-auto-research-module",
  "data": {
    "content": "{{json content}}",
    "init": "AutoLoansPrequalAutoResearchModule"
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.auto-loans.utilities/prequal-marketing-code-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @class PrequalAutoResearchModule
 * @extends {Module}
 */
class PrequalAutoResearchModule extends Module {
  /**
   * Creates an instance of PrequalAutoResearchModule.
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Inits marketing code utility
   * @returns {void}
   */
  init() {
    vlpqMarketingUtility.init();
  }
}
registerModuleClass({
  moduleClass: PrequalAutoResearchModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { PrequalAutoResearchModule as default, moduleConfig };
